import React from 'react';
import { Sparkles, ChevronDown, ChevronUp } from 'lucide-react';

const AISummary = ({ summary }) => {
  const [expanded, setExpanded] = React.useState(false);

  if (!summary) return null;

  return (
    <div className="bg-gradient-to-r from-purple-50 to-blue-50 rounded-lg p-6 mb-6">
      <div className="flex items-start gap-3 mb-3">
        <div className="p-2 bg-white rounded-lg shadow-sm">
          <Sparkles className="w-5 h-5 text-purple-600" />
        </div>
        <div>
          <h3 className="font-semibold text-[#1a1a1a]">{summary.title}</h3>
          <p className="text-sm text-gray-500">{summary.subtitle}</p>
        </div>
      </div>
      
      <p className="text-sm text-gray-700 leading-relaxed">
        {expanded ? summary.content : summary.content.substring(0, 300) + '...'}
      </p>
      
      <button
        onClick={() => setExpanded(!expanded)}
        className="flex items-center gap-1 text-sm text-[#1a1a1a] font-medium hover:underline mt-3"
      >
        {expanded ? 'Voir moins' : 'Voir plus'}
        {expanded ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
      </button>
    </div>
  );
};

export default AISummary;
